<div class="container">
	<div class="financial-form-title">{{ 'FINANCIAL_FORM.TITLE' | translate }}</div>
	<div class="close-button-container" (click)="dismiss()"></div>
	<form [formGroup]="form">
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.NET_AMOUNT' | translate }} </label>
			<input type="number" formControlName="netAmount" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.COST' | translate }} </label>
			<input readonly type="number" formControlName="cost" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.DURATION' | translate }} </label>
			<input readonly type="text" value="{{ 'FINANCIAL_FORM.YEARS' | translate }}"/>
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.PERIODICITY' | translate }} </label>
			<input readonly type="text" value="{{ 'FINANCIAL_FORM.MONTHLY' | translate }}"/>
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.OPTION' | translate }} </label>
			<input type="number" formControlName="optionPurchase" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.ANTICIP_AMOUNT_PERC' | translate }} </label>
      <!-- label="{{ 'FINANCIAL_FORM.ANTICIP_AMOUNT_PERC' | translate }}" -->
      <ion-select
        interface="action-sheet"
        formControlName="percentage"
      >
        <ion-select-option [value]="10">10%</ion-select-option>
        <ion-select-option [value]="15">15%</ion-select-option>
        <ion-select-option [value]="20">20%</ion-select-option>
      </ion-select>
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.ANTICIPATED_AMOUNT' | translate }} </label>
			<input readonly type="number" formControlName="anticipAmount" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.SPES_ISTRUCTOR' | translate }} </label>
			<input readonly type="number" formControlName="processingFees" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.PARTIAL_AMOUNT' | translate }} </label>
			<input readonly type="number" formControlName="partialAmount" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.NUMBER_OF_CANON' | translate }} </label>
			<input readonly type="number" value="59"/>
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.CANON_AMOUNT' | translate }} </label>
			<input readonly type="number" formControlName="canonAmount" />
		</div>
		<div class="field-container">
			<label>{{ 'FINANCIAL_FORM.TOTAL_AMOUNT' | translate }} </label>
			<input readonly type="number" formControlName="totalAmount" />
		</div>
	</form>
</div>
